import request from "../utils/request";

var user = '/user'

// 查询所有api key
export function queryApiKey(data){
  return request({
    url: user+'/v3/apikeys',
    method: 'get',
    data
  })
}

// 是否已经完成首次充值 (apikey)
export function isFirtsRecharge(data){
  return request({
    url: user+'/v3/apikeys/recharge',
    method: 'get',
    data
  })
}

//创建api key
export function addApiKey(data) {
  return request({
    url: user + '/v3/apikeys',
    method: 'post',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    data
  })
}

//续签api key
export function continueApiKey (id) {
  return request({
      method: 'post',
      url: user + `/v3/apikeys/delay/${id}`,
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  })
}

//删除api key
export function removeApiKey (id) {
  return request({
      method: 'post',
      url: user + `/v3/apikeys/remove/${id}`,
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  })
}

//编辑api Key
export function editApiKey (id,data) {
  return request({
      method: 'post',
      url: user + `/v3/apikeys/${id}`,
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      data
  })
}


// WEBPACK FOOTER //
// ./src/api/apikey.js